import DPSwitch from "framework/widgets/DPSwitch"
import React from "react"
import { CardText, Col, Row } from "reactstrap"

import DPTextBox from "../../../framework/components/DPTextBox"

const offsymble = () => {
    return (
        <div>

        </div>
    )
}

const onsymble = () => {
    return (
        <div></div>
    )
}

export const TransactionTypeMasterTab1 = () => {
    return (
        <React.Fragment>
            <div>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Row>
                            <Col sm={12} md={8} className="mb-4-sm">
                                <div>
                                    <DPTextBox
                                        rowClass="mb-4-sm"
                                        labelText="Code"
                                        textType="text"
                                        maxLength="8"
                                    />
                                </div>
                                <div>
                                    <DPTextBox
                                        rowClass="mb-4-sm"
                                        labelText="Description"
                                        textType="text"
                                        maxLength="8"
                                    />
                                </div>

                                <table style={{ alignItems: "start", justifyContent: "left", alignContent: "flex-start" }}>
                                    <tbody>
                                        <tr>
                                            <td>Receipt / Withdrawal Mode  </td>
                                            <td><div style={{ marginLeft: "30px", marginTop: "10px" }}>
                                                <DPSwitch
                                                    uncheckedIcon={offsymble}
                                                    checkedIcon={onsymble} />
                                            </div>
                                            </td>
                                            <td><lebal>RECEIPT</lebal></td>
                                        </tr>
                                        <p></p>
                                        <tr>
                                            <td>Back Office Transaction</td>
                                            <td><div style={{ marginLeft: "30px", marginTop: "10px" }}>
                                                <DPSwitch
                                                    uncheckedIcon={offsymble}
                                                    checkedIcon={onsymble} />
                                            </div>
                                            </td>

                                            <td>YES</td>
                                        </tr>
                                        <p></p>
                                        <tr>
                                            <td>Back Office Transaction<br>
                                            </br> Type (Optional) </td>
                                            <td colspan="2">
                                                <DPTextBox
                                                    rowClass="mb-4-sm"
                                                    textType="text"
                                                />
                                            </td>

                                        </tr>
                                    </tbody>

                                </table>

                                <table style={{ alignItems: "start", justifyContent: "left", alignContent: "flex-start" }}>
                                    <tbody>
                                        <p></p>
                                        <tr>
                                            <td>Skip credit limit check in BK</td>
                                            <td><div style={{ marginLeft: "1px", marginTop: "10px" }}>
                                                <DPSwitch
                                                    uncheckedIcon={offsymble}
                                                    checkedIcon={onsymble} />
                                            </div>
                                            </td>
                                            <td style={{ marginLeft: "50px", marginTop: "10px" }}>
                                                <lebal>YES(Do not check credit <br />
                                                    in the back office transactions<br />
                                                    for this mode)</lebal></td>
                                        </tr>
                                        <p></p>

                                        <tr>
                                            <td>
                                                <div style={{ color: "gray", marginTop: "-50" }}>
                                                    <b>Receipt/Withdrawal Mode</b></div>
                                            </td>
                                            <td>

                                            </td>
                                            <td>
                                                <p></p>
                                                <p></p>
                                                <div style={{ color: "gray", marginTop: "20" }}>
                                                    These modes are shown in the myCheckout <br />
                                                    Cash Receipts / Withdrawals options. You can <br />
                                                    use these types to reconcile your cash<br />
                                                    balances at the cashier counter
                                                </div>
                                            </td>
                                        </tr>
                                        <p></p>
                                        <tr>
                                            <td>
                                                <div style={{ color: "gray", marginTop: "-50" }}>
                                                    <b>Back Office Transaction Types</b></div>
                                            </td>
                                            <td>

                                            </td>
                                            <td>
                                                <p></p>
                                                <p></p>
                                                <div style={{ color: "gray", marginTop: "20" }}>
                                                    These modes are shown in transactions ar the <br />
                                                    myOffice, where you can assign a specific <br />
                                                    type to a transaction so that you would be <br />
                                                    able to drill down reports based on these types.
                                                </div>
                                            </td>
                                        </tr>

                                    </tbody>

                                </table>

                            </Col>
                        </Row>
                    </CardText>
                </Col>
            </div>
        </React.Fragment>

    )
}
